import React, {useEffect, useState, useMemo} from "react";
import {TextField, InputAdornment, Select, MenuItem, Autocomplete} from "@mui/material";
import {useTranslation} from "react-i18next";
import {countries} from "../locales/LicensePlateInput";


export function LicensePlateInput({handle, val, disabled = false, errorStatus = false}) {
    const {i18n, t} = useTranslation();
    const currentLang = i18n.language.split('-')[0];

    const [license, setLicense] = useState(val ? val : "");
    const [error, setError] = useState(false);
    const country = countries[currentLang];
    const handleLicenseChange = (e) => {
        const value = e.target.value.toUpperCase();
        setLicense(value);
        const regex = country.mask;
        setError(regex && value ? !regex.test(value) : false);
    };
    useEffect(() => {
        const regex = country.mask;
        setError(regex && license ? !regex.test(license) : false);
    }, [country, license])

    useEffect(() => {
        if (!license) {
            handle(null);
            return;
        }
        if (license) {
            handle(license);
        }
    }, [license, error, handle]);

    /* const handleCountryChange = (e) => {
         const code = e.target.value;
         const newCountry = countryOptions.find(c => c.code === code);
         setCountry(newCountry);

         const regex = newCountry.mask;
         setError(regex ? !regex.test(license.toUpperCase()) : false);
     };*/

    return (
        <TextField
            label={!disabled ? t('license_plate_label') : t('license_plate_info')}
            value={license}
            onChange={handleLicenseChange}
            error={errorStatus}
            disabled={disabled}
            helperText={error ? t('license_plate_error') : ""}
            size="small"
            fullWidth
           // inputProps={{maxLength: country.maxLength}}
             InputProps={{
                 /*startAdornment: (
                      <InputAdornment position="start" sx={{ mr: 1 }}>
                          <TextField
                              select
                              value={country.code}
                              onChange={handleCountryChange}
                              variant="standard"
                              size="small"

                              sx={{
                                  width: 70,
                                  '.MuiSelect-select': { padding: '0 4px', textAlign: 'center' }
                              }}
                          >
                              {countryOptions.map(option => (
                                  <option key={option.code} value={option.code}>
                                      {option.code}
                                  </option>
                              ))}
                          </TextField>
                      </InputAdornment>
                  ),*/
           /* endAdornment: (
                <InputAdornment position="end" sx={{ml: 1, width: 290}}>
                    <Autocomplete
                        options={countryOptions[0].regionsCountry}
                        getOptionLabel={(option) => `${option.code} - ${option.name}`}
                        value={countryOptions[0].regionsCountry[0]}
                        onChange={(event, newValue, reason) => {
                            if (reason === "clear") {
                                console.log("Очистили через стандартный крестик");
                                setRegion(countryOptions[0].regionsCountry[0])
                                return;
                            }
                             setRegion(newValue)
                        }}

                        size="small"
                        sx={{width: 200}}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                size="small"
                                sx={{'.MuiInputBase-input': {padding: '2px 4px'}}}
                            />
                        )}
                    />
                </InputAdornment>
            )*/
        }}
        />
    );
}
